import { gate } from 'hub-http/gates';
import { useMemo } from 'react';
import { useGetIsUngated } from '../../auth/hooks/useGetIsUngated';
export const useIsUngatedForLoadableTools = () => {
  const isUngated = useGetIsUngated();
  return useMemo(() => isUngated(gate('BreezeAssistant:Brain:LoadableTools')), [isUngated]);
};